module.exports = __webpack_public_path__ + "1_0_59/img/assign_task.85924ae5.svg";